import React, { Component } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import BasicDetailsCalendar from './BasicCalendar/';
import loader from '../ProjectBrief/loader.gif';

class BasicDetails extends Component {
  constructor(props) {
    super(props);
    this.getDayStyle = this.getDayStyle.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  getLastTooSoonDate = () => {
    const { tooSoonDays } = this.props;
    return moment()
      .startOf('day')
      .add(tooSoonDays, 'day');
  };

  getDayStyle(day) {
    const { deadline: deadlineStr } = this.props;
    const deadline = moment(deadlineStr, 'DD-MM-YYYY').startOf('day');
    const today = moment().startOf('day');

    if (day.isSame(deadline)) {
      return 'r-selected';
    }

    if (day.isSame(today)) {
      return 'today-date-cell';
    }

    return 'simple-day-cell';
  }

  onChange(deadline) {
    const { handleAddDeadline } = this.props;
    handleAddDeadline(deadline);
  }

  render() {
    const {
      projectName,
      handleProjectBriefInput,
      handleProjectUpload,
      isUploadingProjectPicture,
      projectPicture,
      handleRemoveUpload,
    } = this.props;

    return (
      <div className="col-12">
        <div className="card card-dash-calendar">
          <div className="row m-0">
            <div className="col-12 col-md-6 bg-blue-light p-4 p-lg-5">
              <input
                type="text"
                name="project_name"
                placeholder="Project Name"
                onChange={handleProjectBriefInput}
                defaultValue={projectName}
                autoComplete="off"
                className="new-account__content-input mb-5"
              />
              {projectPicture && (
                <div className="mx-auto">
                  <p className="t-14 font-weight-bold mb-4 text-gray-2">
                    Project Image (Optional)
                  </p>
                  <div className="project-brief-card__content project-brief-card__content--picture">
                    <img
                      alt="project"
                      src={projectPicture}
                      className="project-brief-card__content--picture-cover"
                    />
                    <div className="remove-image-overlay">
                      <a
                        onClick={event =>
                          handleRemoveUpload(
                            event,
                            projectPicture,
                            'project_picture',
                          )
                        }
                        className="t-14 font-weight-bold mb-4 text-white remove-link"
                      >
                        Remove Project Image
                      </a>
                    </div>
                  </div>
                </div>
              )}

              {!projectPicture && (
                <div className="">
                  <p className="t-14 font-weight-bold mb-4 text-gray-2">
                    Project Image (Optional)
                  </p>
                  <div className="project-brief-card__content project-brief-card__content--picture">
                    <label
                      className="project-brief-card__uploader-picture"
                      htmlFor="picture"
                    >
                      <input
                        id="picture"
                        type="file"
                        name="profilePicture"
                        accept="image/*"
                        onChange={event =>
                          handleProjectUpload(event, 'project_picture')
                        }
                      />
                      {!isUploadingProjectPicture && (
                        <span className="project-brief-card__uploader-picture--icon" />
                      )}

                      {isUploadingProjectPicture && (
                        <div className="project-brief-loader">
                          <img src={loader} alt="Project Loader" />
                        </div>
                      )}
                    </label>
                  </div>
                </div>
              )}
            </div>
            <div className="col-12 col-md-6 p-lg-5">
              <div className="row">
                <div className="col-12">
                  <p className="t-14 font-weight-bold mb-4 text-gray-2">
                    Deadline
                  </p>
                </div>
              </div>

              <div className="row">
                <BasicDetailsCalendar
                  onChange={this.onChange}
                  getDayStyle={this.getDayStyle}
                  rushFeeDays={7}
                  containerClassName="col-12"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderPopupContent(deadline) {
    return deadline.isAfter(this.getLastTooSoonDate())
      ? this.renderRushFeeContent()
      : this.renderTooSoonContent();
  }

  renderRushFeeContent() {
    return (
      <div className="basic-details-card--inner-rush-fee">
        <div className="basic-details-card--inner-header">Rush Fee</div>
        <div className="basic-details-card--inner-icon">
          <div className="basic-details-card--inner-icon-rush-fee" />
        </div>
        <div className="basic-details-card--inner-content">
          Your project will need to be handled by an account manager to meet
          this deadline.
        </div>
      </div>
    );
  }
  renderTooSoonContent() {
    return (
      <div className="basic-details-card--inner-too-soon">
        <div className="basic-details-card--inner-icon">
          <div className="basic-details-card--inner-icon-too-soon" />
        </div>
        <div className="basic-details-card--inner-header">
          Too Soon: Please pick a later date
        </div>
      </div>
    );
  }
}

BasicDetails.propTypes = {
  handleAddDeadline: PropTypes.func,
  deadline: PropTypes.string,
  tooSoonDays: PropTypes.number,
  projectName: PropTypes.string,
  handleProjectBriefInput: PropTypes.func,
  handleProjectUpload: PropTypes.func,
  isUploadingProjectPicture: PropTypes.bool,
  projectPicture: PropTypes.string,
  handleRemoveUpload: PropTypes.func,
};

export default BasicDetails;



// WEBPACK FOOTER //
// ./src/components/BasicDatails/BasicDetails.js